/**
 * Volume-weighted prescribed RPE (calendar `getWeightedRpe` pattern) for Program Insights.
 */

import { parseRpeNumericForHistogram } from "./insightsDistributions";
import {
  estimatedRepsForSetRow,
  isAmrapSetRow,
  parsePositiveNumber,
} from "./insightsSetRowMath";
import { rpeMidpoint } from "../../../../../utils/rpe-range";

/** @returns {{ weightedRpeSum: number, rpeVolumeWeight: number }} */
export function createEmptyPrescribedRpeAccumulator() {
  return { weightedRpeSum: 0, rpeVolumeWeight: 0 };
}

/** Function to accumulate the prescribed RPE for a row.
 * @param {object} row
 * @param {number} mult
 * @param {object} exercise
 * @param {{ weightedRpeSum: number, rpeVolumeWeight: number }} acc
 */
export function accumulatePrescribedAvgRpeRow(row, mult, exercise, acc) {
  if (isAmrapSetRow(row)) {
    return;
  }
  const rpe = parseRpeNumericForHistogram(rpeMidpoint(row));
  if (rpe == null) {
    return;
  }
  const loadKg = parsePositiveNumber(row?.load);
  const reps = estimatedRepsForSetRow(row, exercise);
  if (loadKg <= 0 || reps <= 0) {
    return;
  }
  const weight = mult * loadKg * reps;
  acc.weightedRpeSum += rpe * weight;
  acc.rpeVolumeWeight += weight;
}

/** Function to finalize the prescribed RPE for a row.
 * @param {{ weightedRpeSum: number, rpeVolumeWeight: number }} acc
 * @returns {number|null} mean on the RPE 5–10 axis
 */
export function finalizeAvgPrescribedRpe(acc) {
  if (!acc.rpeVolumeWeight || acc.rpeVolumeWeight <= 0) {
    return null;
  }
  return acc.weightedRpeSum / acc.rpeVolumeWeight;
}
